import { routes } from "../../../routes/routes";
import { findCurrectPermission } from "../../../helpers/roles-and-permissions";
import { enums } from "../../../enums/Enums";
const encryptedUserId = localStorage.getItem("encryptedUserId");
// const name = username.name ? JSON.parse(username.name) : null;

//  console.log(username.name)
const Menuitems = () => {
  const storedUser = localStorage.getItem("user");
  const UserName = storedUser ? JSON.parse(storedUser) : {};
  const showDepartmentalApplications = findCurrectPermission(
    enums.UserPermissionNames.FTO_SUBMIT_NEW_REQUEST,
  );

  return [
    {
      navlabel: true,
      subheader: "GENERAL",
      icon: "mdi mdi-dots-horizontal",
      href: routes?.dashboard?.match,
      display: true,
    },
    {
      title: "Modern",
      icon: "hard-drive",
      href: "/dashboards/dashboard3",
      display: false,
    },
    {
      title: "Dashboard",
      icon: "pie-chart",
      href: routes?.dashboard?.match,
      display: true,
    },
    {
      title: "eCommerce",
      icon: "shopping-bag",
      href: "/dashboards/dashboard2",
    },

    {
      title: "Leave - Pass Mgt.",
      icon: "calendar",
      href: "/time-attendance",
      collapse: true,
      display:
        findCurrectPermission(enums.UserPermissionNames.T_A_IN_OUT_FOR_LUNCH) ||
        findCurrectPermission(
          enums.UserPermissionNames.T_A_IN_OUT_FOR_BUSINESS,
        ) ||
        findCurrectPermission(
          enums.UserPermissionNames.T_A_IN_OUT_FOR_PERSONAL_BUSINESS,
        ) ||
        findCurrectPermission(
          enums.UserPermissionNames.T_A_MY_MISSING_PUNCHES,
        ) ||
        findCurrectPermission(
          enums.UserPermissionNames.T_A_MY_TIME_PUNCH_RECORDS,
        ) ||
        findCurrectPermission(
          enums.UserPermissionNames.T_A_WHO_IS_IN_THE_BUILDING,
        ) ||
        findCurrectPermission(enums.UserPermissionNames.DOCUMENTS_ALL) ||
        findCurrectPermission(
          enums.UserPermissionNames.FTO_SUBMIT_NEW_REQUEST,
        ) ||
        findCurrectPermission(enums.UserPermissionNames.FTO_APPROVE) ||
        findCurrectPermission(enums.UserPermissionNames.FTO_HR_APPROVAL) ||
        findCurrectPermission(
          enums.UserPermissionNames.FTO_REVIEW_YTD_STATUS,
        ) ||
        findCurrectPermission(enums.UserPermissionNames.FTO_SHOW_ALL_DEPT) ||
        findCurrectPermission(
          enums.UserPermissionNames.FTO_SHOW_ALL_FUTURE_DEPT,
        )
          ? true
          : false,
      children: [
        {
          title: "In/Out For Punches",
          icon: "list",
          href: routes?.attendanceForLunch?.match,
          display: findCurrectPermission(
            enums.UserPermissionNames.T_A_IN_OUT_FOR_LUNCH,
          )
            ? true
            : false,
        },
        {
          title: "Visitor & Attendance Dashboard",
          icon: "list",
          href: routes?.visitorPassDashboard?.match,
          display: true,
          // display: findCurrectPermission(
          //   enums.UserPermissionNames.AttendanceDashboard,
          // )
          //   ? true
          //   : false,
        },
        // {
        //   title: "In/ Out For Business",
        //   icon: "list",
        //   href: routes?.attendanceForBusiness?.match,
        //   display: findCurrectPermission(
        //     enums.UserPermissionNames.T_A_IN_OUT_FOR_BUSINESS,
        //   )
        //     ? true
        //     : false,
        // },
        // {
        //   title: "In/Out For Personal Business",
        //   icon: "list",
        //   href: routes?.attendanceForPersonalBusiness?.match,
        //   display: findCurrectPermission(
        //     enums.UserPermissionNames.T_A_IN_OUT_FOR_PERSONAL_BUSINESS,
        //   )
        //     ? true
        //     : false,
        // },
        {
          title: "My Time Punch Records",
          icon: "list",
          href: "/time-attendance/punch-records",
          display: findCurrectPermission(
            enums.UserPermissionNames.T_A_MY_TIME_PUNCH_RECORDS,
          ),
        },
        // {
        //   title: "My Missing Punches",
        //   icon: "list",
        //   href: routes?.missingPunch?.match,
        //   display: findCurrectPermission(
        //     enums.UserPermissionNames.T_A_MY_MISSING_PUNCHES,
        //   )
        //     ? true
        //     : false,
        // },
        {
          title: "Who's In The Building",
          icon: "list",
          href: routes?.building?.match,
          display: findCurrectPermission(
            enums.UserPermissionNames.T_A_WHO_IS_IN_THE_BUILDING,
          )
            ? true
            : false,
        },
        {
          title: "New Leave Request",
          icon: "list",
          href: routes?.ftoCreate?.match,
          display: findCurrectPermission(
            enums.UserPermissionNames.FTO_SUBMIT_NEW_REQUEST,
          )
            ? true
            : false,
        },
        {
          title: "Approve FTO",
          icon: "list",
          href: routes?.ftoApprove?.match,
          display: findCurrectPermission(enums.UserPermissionNames.FTO_APPROVE)
            ? true
            : false,
        },

        {
          title: "FTO's HR Approval",
          icon: "list",
          href: routes?.ftoHrApprove?.match,
          display: findCurrectPermission(
            enums.UserPermissionNames.FTO_HR_APPROVAL,
          )
            ? true
            : false,
        },
        {
          title: "View Leave Status",
          icon: "list",
          href: routes?.ftoReviewYTD?.match,
          display: findCurrectPermission(
            enums.UserPermissionNames.FTO_REVIEW_YTD_STATUS,
          )
            ? true
            : false,
        },

        {
          title: "Show All FTO's Of My Dept.",
          icon: "list",
          href: routes?.ftoAllDepartment?.match,
          display: findCurrectPermission(
            enums.UserPermissionNames.FTO_SHOW_ALL_DEPT,
          )
            ? true
            : false,
        },
        // {
        //   title: "Show All Future FTO's Of My Dept.",
        //   icon: "list",
        //   href: routes?.ftoFutureDepartment?.match,
        //   display: findCurrectPermission(
        //     enums.UserPermissionNames.FTO_SHOW_ALL_FUTURE_DEPT,
        //   )
        //     ? true
        //     : false,
        // },
        {
          title: "Visitors Pass",
          icon: "list",
          href: routes?.allvisitorlist?.match,
          display: findCurrectPermission(
            enums.UserPermissionNames.FTO_Addvisitor,
          )
            ? true
            : false,
        },
      ],
    },
    // {
    //   title: "Gatepass",
    //   icon: "pie-chart",
    //   href: `http://localhost:3001/Login?username=${username.name}`,
    //   display: findCurrectPermission(
    //         enums.UserPermissionNames.T_A_MY_TIME_PUNCH_RECORDS
    //       )
    //         ? true
    //         : false,

    // },

    {
      title: "Expense Purchase Order",
      icon: "file-text",
      href: "/epo",
      collapse: true,
      display:
        findCurrectPermission(enums.UserPermissionNames.EPO_Manage) ||
        findCurrectPermission(enums.UserPermissionNames.EPO_MPC_EPO_VIEWER) ||
        findCurrectPermission(enums.UserPermissionNames.EPO_MPC_VOTE_FOR_EPO) ||
        findCurrectPermission(enums.UserPermissionNames.EPO_MY_EPOS) ||
        findCurrectPermission(
          enums.UserPermissionNames.FTO_REVIEW_YTD_STATUS,
        ) ||
        findCurrectPermission(
          enums.UserPermissionNames.EPO_VIEW_MY_SUB_ORDINATES_EPO,
        ) ||
        findCurrectPermission(enums.UserPermissionNames.EPO_MY_APPROVAL_FOR_EPO)
          ? true
          : false,
      children: [
        {
          title: "Manage EPO",
          icon: "list",
          href: routes?.epoCreate?.match,
          display: findCurrectPermission(enums.UserPermissionNames.EPO_Manage)
            ? true
            : false,
        },

        {
          title: "EPO Dashboard",
          icon: "pie-chart",
          href: routes?.epoDashboard?.match,
          display: findCurrectPermission(
            enums.UserPermissionNames.EPO_DASHBOARD,
          )
            ? true
            : false,
          // display: true,
        },
        // {
        //   title: "Edit EPO",
        //   icon: "list",
        //   href: routes?.epoEdit?.match,
        // },
        {
          title: "EPO Viewer",
          icon: "list",
          href: routes?.epoDetail?.match,
          subChild: {
            href: [routes?.epoView?.matchSidebar.find((x) => x).url1],
          },
          display: findCurrectPermission(
            enums.UserPermissionNames.EPO_MPC_EPO_VIEWER,
          )
            ? true
            : false,
        },
        {
          title: "MPC vote for EPO",
          icon: "list",
          isCountMpcVote: true,
          href: routes?.epoVote?.match,
          subChild: {
            href: [routes?.epoView?.matchSidebar.find((x) => x).url2],
          },
          display: findCurrectPermission(
            enums.UserPermissionNames.EPO_MPC_VOTE_FOR_EPO,
          )
            ? true
            : false,
        },
        {
          title: "My EPOs",
          icon: "list",
          href: routes?.epoList?.match,
          subChild: {
            href: [routes?.epoView?.matchSidebar.find((x) => x).url3],
          },
          display: findCurrectPermission(enums.UserPermissionNames.EPO_MY_EPOS)
            ? true
            : false,
        },
        // {
        //   title: "EPO's not ready for payment",
        //   icon: "list",
        //   href: routes?.epoPayment?.match,
        // },
        {
          title: "View My Subordinate's EPO",
          icon: "list",
          href: routes?.epoSubordinate?.match,
          subChild: {
            href: [routes?.epoView?.matchSidebar.find((x) => x).url4],
          },
          display: findCurrectPermission(
            enums.UserPermissionNames.EPO_VIEW_MY_SUB_ORDINATES_EPO,
          )
            ? true
            : false,
        },
        {
          title: "Approval for Higher Authority EPO",
          icon: "list",
          isEpoApprovalTotal: true,
          href: routes?.epoDirectorApproval?.match,
          subChild: {
            href: [routes?.epoView?.matchSidebar.find((x) => x).url5],
          },
          // display: true,
          display: findCurrectPermission(
            enums.UserPermissionNames.EPO_Approval_for_Higher_Authority,
          )
            ? true
            : false,
        },
        {
          title: "My Approval for EPO",
          icon: "list",
          islength: true,
          isCountMyApproval: true,
          href: routes?.epoApproval?.match,
          subChild: {
            href: [routes?.epoView?.matchSidebar.find((x) => x).url5],
          },
          display: findCurrectPermission(
            enums.UserPermissionNames.EPO_MY_APPROVAL_FOR_EPO,
          )
            ? true
            : false,
        },
      ],
    },

    {
      title: "Document Management System",
      icon: "layout",
      href: "/document-management",
      collapse: true,
      display:
        findCurrectPermission(enums.UserPermissionNames.DOCUMENTS_ALL) ||
        findCurrectPermission(
          enums.UserPermissionNames.DOCUMENTS_CREATE_NEW_ECN,
        ) ||
        findCurrectPermission(
          enums.UserPermissionNames.DOCUMENTS_CREATE_NEW_FCD,
        ) ||
        findCurrectPermission(
          enums.UserPermissionNames.DOCUMENTS_CREATE_NEW_LIT,
        ) ||
        findCurrectPermission(
          enums.UserPermissionNames.DOCUMENTS_CREATE_NEW_SOP,
        ) ||
        findCurrectPermission(
          enums.UserPermissionNames.DOCUMENTS_CREATE_NEW_WI,
        ) ||
        findCurrectPermission(
          enums.UserPermissionNames.DOCUMENTS_AWAITING_MY_APPROVAL,
        )
          ? true
          : false,
      children: [
        {
          title: "All Documents",
          icon: "list",
          href: routes?.allDocuments?.match,
          display: findCurrectPermission(
            enums.UserPermissionNames.DOCUMENTS_ALL,
          )
            ? true
            : false,
        },
        {
          title: "Create New ECN",
          icon: "list",
          href: routes?.createECN?.match,
          display: findCurrectPermission(
            enums.UserPermissionNames.DOCUMENTS_CREATE_NEW_ECN,
          )
            ? true
            : false,
        },
        {
          title: "Create New FCD",
          icon: "list",
          href: routes?.createFCD?.match,
          display: findCurrectPermission(
            enums.UserPermissionNames.DOCUMENTS_CREATE_NEW_FCD,
          )
            ? true
            : false,
        },
        {
          title: "Create New LIT",
          icon: "list",
          href: routes?.createLIT?.match,
          display: findCurrectPermission(
            enums.UserPermissionNames.DOCUMENTS_CREATE_NEW_LIT,
          )
            ? true
            : false,
        },
        {
          title: "Create New SOP",
          icon: "list",
          href: routes?.createSOP?.match,
          display: findCurrectPermission(
            enums.UserPermissionNames.DOCUMENTS_CREATE_NEW_SOP,
          )
            ? true
            : false,
        },
        {
          title: "Create New WI",
          icon: "list",
          href: routes?.createWI?.match,
          display: findCurrectPermission(
            enums.UserPermissionNames.DOCUMENTS_CREATE_NEW_WI,
          )
            ? true
            : false,
        },
        {
          title: "Document Awaiting My Approval",
          icon: "list",
          isTotal: true,
          href: routes?.documentMyApproval?.match,
          display: findCurrectPermission(
            enums.UserPermissionNames.DOCUMENTS_AWAITING_MY_APPROVAL,
          )
            ? true
            : false,
        },
      ],
    },
    {
      title: "HR Management",
      icon: "user",
      href: "/hr",
      collapse: true,
      display:
        // findCurrectPermission(enums.UserPermissionNames.HR_PreRecruitment_Process) ||
        findCurrectPermission(enums.UserPermissionNames.HR_All_Recruitees) ||
        findCurrectPermission(
          enums.UserPermissionNames.HR_Email_For_Training,
        ) ||
        findCurrectPermission(enums.UserPermissionNames.HR_EOM_HR) ||
        findCurrectPermission(enums.UserPermissionNames.HR_EmployeeApproval) ||
        findCurrectPermission(
          enums.UserPermissionNames.HR_Lets_Know_Each_other_details,
        ) ||
        findCurrectPermission(enums.UserPermissionNames.HR_EmployeeApproval) ||
        findCurrectPermission(
          enums.UserPermissionNames.HR_Welcome_New_Employee,
        ) ||
        findCurrectPermission(enums.UserPermissionNames.HR_Gate_Pass) ||
        findCurrectPermission(enums.UserPermissionNames.HR_Leave_Sheet) ||
        findCurrectPermission(enums.UserPermissionNames.HR_Training) ||
        findCurrectPermission(enums.UserPermissionNames.HR_Training_Courses) ||
        // findCurrectPermission(enums.UserPermissionNames.ADMIN_ADD_EMPLOYEE) ||
        findCurrectPermission(enums.UserPermissionNames.HR_Employees) ||
        findCurrectPermission(enums.UserPermissionNames.HR_AddQuestion) ||
        findCurrectPermission(enums.UserPermissionNames.HR_ALLQuestion) ||
        findCurrectPermission(
          enums.UserPermissionNames.HR_GetCandidateResume,
        ) ||
        findCurrectPermission(enums.UserPermissionNames.HR_AllCandidateCV) ||
        findCurrectPermission(enums.UserPermissionNames.HR_AddCandidateResume)
          ? true
          : false,
      children: [
        // {
        //   title: "Add Employee",
        //   icon: "list",
        //   href: routes?.addemployee?.match,
        //   display: findCurrectPermission(
        //     enums.UserPermissionNames.ADMIN_ADD_EMPLOYEE
        //   )
        //     ? true
        //     : false,
        // },
        {
          title: "Employees",
          icon: "list",
          href: routes?.limitEmployees.match,
          subChild: {
            href: [
              routes?.editEmployee?.matchSidebar,
              routes?.employeeView?.matchSidebar,
              routes?.addemployee?.match,
            ],
          },
          display: findCurrectPermission(enums.UserPermissionNames.HR_Employees)
            ? true
            : false,
        },
        {
          title: "Employee Approval",
          icon: "check-square",
          href: routes?.employeeApproval?.match,

          display: findCurrectPermission(
            enums.UserPermissionNames.HR_EmployeeApproval,
          )
            ? true
            : false,
        },
        {
          title: "Welcome New Employee",
          icon: "list",
          href: routes?.welcomeNewEmpl?.match,
          display: findCurrectPermission(
            enums.UserPermissionNames.HR_Welcome_New_Employee,
          )
            ? true
            : false,
        },
        // {
        //   title: "Pre-Recruitment Process",
        //   icon: "list",
        //   href: routes?.hrInterviewCreate?.match,
        //   display: findCurrectPermission(enums.UserPermissionNames.HR_PreRecruitment_Process)
        //     ? true
        //     : false,
        // },
        // {
        //   title: "Candidates",
        //   icon: "list",
        //   href: routes?.allRecruitee?.match,
        //   display: findCurrectPermission(enums.UserPermissionNames.HR_All_Recruitees)
        //     ? true
        //     : false,
        // },
        // {
        //   title: "EOM Nomination",
        //   icon: "list",
        //   href: routes?.allNominee?.match,
        //   subChild: {
        //     href: [
        //       routes?.EmployeeOfTheMonthNomination?.match,
        //       routes?.nomineeView?.matchSidebar,
        //     ],
        //   },
        //   display: findCurrectPermission(
        //     enums.UserPermissionNames.HR_Employee_Of_The_Month_Nomination,
        //   )
        //     ? true
        //     : false,
        // },
        // {
        //   title: "EOM Nomination Supervisor Approval",
        //   icon: "list",
        //   href: routes?.GetPendingSupervisorApprovals?.match,
        //   subChild: {
        //     href: [
        //       routes?.EmployeeOfTheMonthNomination?.match,
        //       routes?.nomineeView?.matchSidebar,
        //     ],
        //   },
        //   display: findCurrectPermission(
        //     enums.UserPermissionNames.HR_EOM_Supervisor,
        //   )
        //     ? true
        //     : false,
        // },
        // {
        //   title: "EOM Nomination HR Approval",
        //   icon: "list",
        //   href: routes?.hrNominee?.match,
        //   activePaths: [routes?.hrNominee?.match].filter(Boolean),
        //   display: findCurrectPermission(enums.UserPermissionNames.HR_EOM_HR)
        //     ? true
        //     : false,
        // },
        // {
        //   title: "EOM Nomination MPC Approval",
        //   icon: "list",
        //   href: routes?.mpcNominee?.match,
        //   subChild: {
        //     href: [
        //       routes?.EmployeeOfTheMonthNomination?.match,
        //       routes?.nomineeView?.matchSidebar,
        //     ],
        //   },
        //   display: findCurrectPermission(
        //     enums.UserPermissionNames.HR_EOM_MPC,
        //   )
        //     ? true
        //     : false,
        // },

        {
          title: "Cards",
          icon: "credit-card",
          href: routes?.idCards?.match,
          display: findCurrectPermission(enums.UserPermissionNames.HR_Cards)
            ? true
            : false,
        },
        // {
        //   title: "Let's Know Each other details",
        //   icon: "list",
        //   href: routes?.allLetsKnowEachOtherDetails?.match,
        //   subChild: {
        //     href: [
        //       routes?.addLetsKnowEachOtherDetails?.match,
        //       routes?.letsKnowEachotherDetailsView?.matchSidebar,
        //     ],
        //   },
        //   display: findCurrectPermission(enums.UserPermissionNames.HR_Lets_Know_Each_other_details)
        //     ? true
        //     : false,
        // },
        // {
        //   title: "Gate Pass",
        //   icon: "list",
        //   href: routes?.allGatePass?.match,
        //   subChild: {
        //     href: [
        //       routes?.addGatePass?.match,
        //       routes?.gatePassView?.matchSidebar,
        //     ],
        //   },
        //   display: findCurrectPermission(enums.UserPermissionNames.HR_Gate_Pass)
        //     ? true
        //     : false,
        // },
        // {
        //   title: "Leave Sheet",
        //   icon: "list",
        //   href: routes?.allLeaveSheet?.match,
        //   subChild: {
        //     href: [
        //       routes?.addLeaveSheet?.match,
        //       routes?.viewLeaveSheet?.matchSidebar,
        //     ],
        //   },
        //   display: findCurrectPermission(enums.UserPermissionNames.HR_Leave_Sheet)
        //     ? true
        //     : false,
        // },
        // {
        //   title: "Training Courses",
        //   icon: "list",
        //   href: routes?.allCourseList.match,
        //   subChild: {
        //     href: [
        //       routes?.addCourseForm?.match,
        //       routes?.viewCourseDetails?.matchSidebar,
        //     ],
        //   },
        //   display: findCurrectPermission(
        //     enums.UserPermissionNames.HR_Training_Courses,
        //   )
        //     ? true
        //     : false,
        // },
        {
          title: "Training",
          icon: "list",
          href: routes?.allTrainingList?.match,
          subChild: {
            href: [
              // Training routes
              routes?.addTrainingSheetForm?.match,
              routes?.editTraining?.matchSidebar,
              routes?.viewTraining?.matchSidebar,

              // Course routes - keeps Training active
              routes?.allCourseList?.match,
              routes?.addCourseForm?.match,
              routes?.editCourse?.matchSidebar,
              routes?.viewCourseDetails?.matchSidebar,
            ],
          },
          display: findCurrectPermission(enums.UserPermissionNames.HR_Training)
            ? true
            : false,
        },
        {
          title: "Email For Training",
          icon: "list",
          href: routes?.emailForTraining?.match,
          display: findCurrectPermission(
            enums.UserPermissionNames.HR_Email_For_Training,
          )
            ? true
            : false,
        },
        // {
        //   title: "Add Question",
        //   icon: "list",
        //   href: routes?.addQuestion?.match,
        //   display: findCurrectPermission(enums.UserPermissionNames.HR_AddQuestion)
        //     ? true
        //     : false,
        // },
        {
          title: "All Question",
          icon: "list",
          href: routes?.allQuestionlist?.match,
          subChild: {
            href: [
              routes?.addQuestion?.match,
              routes?.editQuestion?.matchSidebar,
              routes?.questionView?.matchSidebar,
            ],
          },
          display: findCurrectPermission(
            enums.UserPermissionNames.HR_ALLQuestion,
          )
            ? true
            : false,
        },
        {
          title: "Holiday",
          icon: "list",
          href: routes?.allHolidaylist?.match,
          display: findCurrectPermission(
            enums.UserPermissionNames.HR_HolidayList,
          )
            ? true
            : false,
        },
        // {
        //   title: "Add Candidate CV",
        //   icon: "list",
        //   href: routes?.addCandidateCV?.match,
        //   display: findCurrectPermission(
        //     enums.UserPermissionNames.HR_AddCandidateResume
        //   )
        //     ? true
        //     : false,
        // },
        {
          title: "ALL Candidate CV",
          icon: "list",
          href: routes?.getCandidateCV?.match,
          display: findCurrectPermission(
            enums.UserPermissionNames.HR_AllCandidateCV,
          )
            ? true
            : false,
        },
        // no  need to use currently
        // {
        //   title: "Training Module",
        //   icon: "list",
        //   href: routes?.addTrainingSheetForm?.match,
        //   display: findCurrectPermission(enums.UserPermissionNames.DOCUMENTS_ALL)
        //     ? true
        //     : false,
        // },
      ],
    },
    // {
    //   title: "ASAI",
    //   icon: "list",
    //   href: "/asai",
    //   collapse: true,
    //   display: true,
    //   children: [
    //     {
    //       title: "Device Data",
    //       icon: "shopping-cart",
    //       href: routes?.deviceData?.match,
    //       display: true,
    //     },
    //     {
    //       title: "Employee Monthly Attendance",
    //       icon: "calendar",
    //       href: routes?.employeeMonthlyAttendance?.match,
    //       display: true,
    //     },
    //     {
    //       title: "Monthly Punch Report",
    //       icon: "calendar",
    //       href: routes?.monthlyPunchReport?.match,
    //       display: true,
    //     },
    //     {
    //       title: "10 Hours Shift",
    //       icon: "layers",
    //       href: routes?.tenHoursShift?.match,
    //       subChild: {
    //         href: [
    //           routes?.tenHoursImportShift?.match,
    //           routes?.tenHoursViewShift?.match,
    //         ],
    //       },
    //       collapse: true,
    //       display: true,
    //       children: [
    //         {
    //           title: "Import / View Shift",
    //           icon: "list",
    //           href: routes?.tenHoursImportShift?.match,
    //           subChild: {
    //             href: [routes?.tenHoursViewShift?.match],
    //           },
    //           display: true,
    //         },
    //       ],
    //     },
    //     {
    //       title: "10 Hours Shift Reports",
    //       icon: "layers",
    //       href: routes?.tenHoursShiftReports?.match,
    //       subChild: {
    //         href: [
    //           routes?.tenHoursReport?.match,
    //           routes?.tenHoursOffdayReport?.match,
    //           routes?.tenHoursOffdayTimeReport?.match,
    //         ],
    //       },
    //       collapse: true,
    //       display: true,
    //       children: [
    //         {
    //           title: "Report",
    //           icon: "list",
    //           href: routes?.tenHoursReport?.match,
    //           display: true,
    //         },
    //         {
    //           title: "Off Day Report",
    //           icon: "list",
    //           href: routes?.tenHoursOffdayReport?.match,
    //           display: true,
    //         },
    //         {
    //           title: "Off Day Time Report",
    //           icon: "list",
    //           href: routes?.tenHoursOffdayTimeReport?.match,
    //           display: true,
    //         },
    //       ],
    //     },
    //     {
    //       title: "8 Hours Shift",
    //       icon: "layers",
    //       href: routes?.eightHoursShift?.match,
    //       subChild: {
    //         href: [
    //           routes?.eightHoursAddEditShift?.match,
    //           routes?.eightHoursViewShift?.match,
    //         ],
    //       },
    //       collapse: true,
    //       display: true,
    //       children: [
    //         {
    //           title: "Import Shift",
    //           icon: "list",
    //           href: routes?.eightHoursAddEditShift?.match,
    //           subChild: {
    //             href: [routes?.eightHoursViewShift?.match],
    //           },
    //           display: true,
    //         },
    //       ],
    //     },
    //     {
    //       title: "8 Hours shift Reports",
    //       icon: "layers",
    //       href: routes?.eightHoursShiftReports?.match,
    //       subChild: {
    //         href: [
    //           routes?.eightHoursReport?.match,
    //           routes?.eightHoursOvertimeReport?.match,
    //         ],
    //       },
    //       collapse: true,
    //       display: true,
    //       children: [
    //         {
    //           title: "Report",
    //           icon: "list",
    //           href: routes?.eightHoursReport?.match,
    //           display: true,
    //         },
    //         {
    //           title: "Overtime Report",
    //           icon: "list",
    //           href: routes?.eightHoursOvertimeReport?.match,
    //           display: true,
    //         },
    //       ],
    //     },

    //     {
    //       title: "Shift Switch",
    //       icon: "file-text",
    //       href: routes?.shiftSwitch?.match,
    //       display: true,
    //     },
    //     // {
    //     //   title: "Store & House Keeping",
    //     //   icon: "file-text",
    //     //   href: "/asai/store-house-keeping",
    //     //   display: true,
    //     // },
    //     // {
    //     //   title: "Office Employee",
    //     //   icon: "layers",
    //     //   collapse: true,
    //     //   display: true,
    //     //   children: [
    //     //     {
    //     //       title: "Office Employee Missing Punch",
    //     //       icon: "list",
    //     //       href: "/asai/office-employee/office-employee-missing-punch",
    //     //       display: true,
    //     //     },
    //     //     {
    //     //       title: "Office Employee Schedule",
    //     //       icon: "list",
    //     //       href: "/asai/office-employee/office-employee-schedule",
    //     //       display: true,
    //     //     },
    //     //     {
    //     //       title: "View Office Employee Schedule",
    //     //       icon: "list",
    //     //       href: "/asai/office-employee/view-office-employee-schedule",
    //     //       display: true,
    //     //     },
    //     //     {
    //     //       title: "Office Employee",
    //     //       icon: "list",
    //     //       href: "/asai/office-employee/office-employee",
    //     //       display: true,
    //     //     },
    //     //     {
    //     //       title: "Office Employee Abad",
    //     //       icon: "list",
    //     //       href: "/asai/office-employee/office-employee-abad",
    //     //       display: true,
    //     //     },
    //     //   ],
    //     // },
    //     // {
    //     //   title: "Office Supervisor",
    //     //   icon: "layers",
    //     //   collapse: true,
    //     //   display: true,
    //     //   children: [
    //     //     {
    //     //       title: "Supervisor Shift",
    //     //       icon: "list",
    //     //       href: "/asai/office-supervisor/supervisor-shift",
    //     //       display: true,
    //     //     },
    //     //     {
    //     //       title: "View Shift",
    //     //       icon: "list",
    //     //       href: "/asai/office-supervisor/view-shift",
    //     //       display: true,
    //     //     },
    //     //     {
    //     //       title: "Supervisor Report",
    //     //       icon: "list",
    //     //       href: "/asai/office-supervisor/supervisor-report",
    //     //       display: true,
    //     //     },
    //     //     {
    //     //       title: "CNC Supervisor Missing Punch",
    //     //       icon: "list",
    //     //       href: "/asai/office-supervisor/cnc-supervisor-missing-punch",
    //     //       display: true,
    //     //     },
    //     //     {
    //     //       title: "Flex Supervisor Missing Punch",
    //     //       icon: "list",
    //     //       href: "/asai/office-supervisor/flex-supervisor-missing-punch",
    //     //       display: true,
    //     //     },
    //     //   ],
    //     // },
    //   ],
    // },

    {
      title: "Employee of The Month",
      icon: "user",
      href: "/hr",
      collapse: true,

      display:
        findCurrectPermission(
          enums.UserPermissionNames.HR_Employee_Of_The_Month_Nomination,
        ) ||
        findCurrectPermission(enums.UserPermissionNames.HR_EOM_Supervisor) ||
        findCurrectPermission(enums.UserPermissionNames.HR_EOM_MPC)
          ? true
          : false,

      children: [
        {
          title: "EOM Nomination",
          icon: "list",
          href: routes?.allNominee?.match,

          // Add, list, edit and normal nominee view belong to this menu.
          activePaths: [
            routes?.allNominee?.match,
            routes?.EmployeeOfTheMonthNomination?.match,
            routes?.editEmployeeOfTheMonthNomination?.matchSidebar,
            routes?.nomineeView?.matchSidebar,
          ].filter(Boolean),

          display: findCurrectPermission(
            enums.UserPermissionNames.HR_Employee_Of_The_Month_Nomination,
          )
            ? true
            : false,
        },

        {
          title: "EOM Nomination Supervisor Approval",
          icon: "list",
          href: routes?.GetPendingSupervisorApprovals?.match,

          // Do not include the add-nominee route here.
          activePaths: [routes?.GetPendingSupervisorApprovals?.match].filter(
            Boolean,
          ),

          display: findCurrectPermission(
            enums.UserPermissionNames.HR_EOM_Supervisor,
          )
            ? true
            : false,
        },

        {
          title: "EOM Nomination MPC Approval",
          icon: "list",
          href: routes?.mpcNominee?.match,

          activePaths: [
            routes?.mpcNominee?.match,
            routes?.mpcNomineeVoteView?.matchSidebar,
          ].filter(Boolean),

          display: findCurrectPermission(enums.UserPermissionNames.HR_EOM_MPC)
            ? true
            : false,
        },
        {
          title: "EOM Nomination Final List",
          icon: "list",
          href: routes?.finalNomineeList?.match,

          activePaths: [
            routes?.finalNomineeList?.match,
            routes?.mpcNomineeVoteView?.matchSidebar,
          ].filter(Boolean),

          display: findCurrectPermission(
            enums.UserPermissionNames.HR_FinalNomineeList,
          )
            ? true
            : false,
          // display: true,
        },
      ],
    },

    //Bhargav

    {
      title: "Interview",
      icon: "user",
      href: routes?.interviewEvalutionForm?.match,
      display: findCurrectPermission(
        enums.UserPermissionNames.HR_PreRecruitment_Process,
      )
        ? true
        : false,
      children: [
        {
          title: "Interview Form",
          icon: "list",
          href: routes?.hrInterviewCreate?.match,
          display: findCurrectPermission(
            enums.UserPermissionNames.HR_PreRecruitment_Process,
          )
            ? true
            : false,
        },
      ],
    },

    {
      title: "Interview Evalution",
      icon: "user",
      href: routes?.interviewEvaluation?.match,
      collapse: true,
      display:
        findCurrectPermission(enums.UserPermissionNames.HR_EvalutionForm) ||
        findCurrectPermission(enums.UserPermissionNames.HR_EvalutionInterviewee)
          ? true
          : false,
      children: [
        {
          title: "Evalution Form",
          icon: "list",
          href: routes?.interviewEvaluationForm?.match,
          display: findCurrectPermission(
            enums.UserPermissionNames.HR_EvalutionForm,
          )
            ? true
            : false,
        },
        {
          title: "Evaluation Interviewee",
          icon: "list",
          href: routes?.allEvalutionCandidate?.match,
          display: findCurrectPermission(
            enums.UserPermissionNames.HR_EvalutionInterviewee,
          )
            ? true
            : false,
        },
      ],
    },
    //  {
    //   title:  "Interview Process",
    //   icon: "user",
    //     href: routes?.interviewEvaluation?.match,
    //   collapse: true,
    //   display:
    //     findCurrectPermission(enums.UserPermissionNames.HR_PreRecruitment_Process)

    //       ? true
    //       : false,
    //   children: [
    //       {
    //       title: "Pre-Recruitment Process",
    //       icon: "list",
    //       href: routes?.hrInterviewCreate?.match,
    //        display: findCurrectPermission(enums.UserPermissionNames.HR_PreRecruitment_Process)
    //         ? true
    //         : false,
    //     }

    //   ],
    // },
    //  {
    //     title:  "Interview Evalution Process",
    //     icon: "user",
    //       href: routes?.interviewEvaluation?.match,
    //     collapse: true,
    //     display:
    //       findCurrectPermission(enums.UserPermissionNames.HR_Genral_Evalution)

    //         ? true
    //         : false,
    //     children: [

    //       {
    //         title: "EvalutionForm",
    //         icon: "list",
    //         href: routes?.interviewEvaluationForm?.match,
    //         display: findCurrectPermission(
    //           enums.UserPermissionNames.HR_Genral_Evalution
    //         )
    //           ? true
    //           : false,

    //       }

    //     ],
    //   },

    ////

    {
      title: "Change Request",
      icon: "file-text",
      href: "/cr",
      collapse: true,
      display:
        findCurrectPermission(enums.UserPermissionNames.AllChangeRequest) ||
        findCurrectPermission(enums.UserPermissionNames.AddChangeRequest)
          ? true
          : false,
      children: [
        {
          title: "New Change Request",
          icon: "list",
          href: routes?.crCreate?.match,
          display: findCurrectPermission(
            enums.UserPermissionNames.AddChangeRequest,
          )
            ? true
            : false,
        },
        {
          title: "All Change Request",
          icon: "list",
          href: routes?.allChangeRequest?.match,
          subChild: {
            href: [
              // routes?.addTrainingSheetForm?.match,
              routes?.editCR?.matchSidebar,
              routes?.crView?.matchSidebar,
            ],
          },
          display: findCurrectPermission(
            enums.UserPermissionNames.AllChangeRequest,
          )
            ? true
            : false,
        },
      ],
    },
    {
      title: "Task Management",
      icon: "book-open",
      collapse: true,
      href: routes?.ticket?.match,
      display: true,
      // display: findCurrectPermission(
      //   enums.UserPermissionNames.TICKETS_ALL
      // )
      //   ? true
      //   : false,
      children: [
        {
          title: "List",
          icon: "list",
          href: routes?.ticket?.match,
          subChild: {
            href: [routes?.ticketAdd?.match],
          },
          display: true,
          // display: findCurrectPermission(
          //   enums.UserPermissionNames.TICKETS_ALL
          // )
          //   ? true
          //   : false,
        },
        // {
        //   title: "Add Request/Task",
        //   icon: "plus-circle",
        //   href: routes?.ticketAdd?.match,
        //   display: true,
        //   // display: findCurrectPermission(
        //   //   enums.UserPermissionNames.TICKETS_ALL
        //   // )
        //   //   ? true
        //   //   : false,
        // },
        {
          title: "Approval Pending",
          icon: "check-circle",
          href: routes?.ticketApproval?.match,
          display: true,
          // display: findCurrectPermission(
          //   enums.UserPermissionNames.TICKETS_ALL
          // )
          //   ? true
          //   : false,
        },
      ],
    },

    {
      title: "Recording",
      icon: "camera",
      collapse: true,
      // href: routes?.ticket?.match,
      // display: true,
      display: findCurrectPermission(
        enums.UserPermissionNames.FTO_SUBMIT_NEW_REQUEST,
      )
        ? true
        : false,
      children: [
        // {
        //   title: "Recording Request",
        //   icon: "camera",
        //   href: routes?.RecordingRequest?.match,
        //   display: findCurrectPermission(
        //     enums.UserPermissionNames.FTO_SUBMIT_NEW_REQUEST,
        //   )
        //     ? true
        //     : false,
        // },
        {
          title: "Recording List",
          icon: "camera",
          href: routes?.Recordinglist?.match,
          subChild: {
            href: [
              routes?.RecordingRequest?.match,
              routes?.Recordinglist?.match,
            ],
          },
          display: findCurrectPermission(
            enums.UserPermissionNames.FTO_SUBMIT_NEW_REQUEST,
          )
            ? true
            : false,
        },
      ],
    },
    // {
    //   title: "Genric Information",
    //   icon: "file-text",
    //   href: "/cr",
    //   collapse: true,
    //   display:
    //     findCurrectPermission(enums.UserPermissionNames.T_A_MY_TIME_PUNCH_RECORDS)
    //       ? true
    //       : false,
    //   children: [
    //     {
    //       title: "Hierarchy chart",
    //       icon: "pie-chart",

    //       href: routes?.hierarchy?.match,
    //       display: findCurrectPermission(
    //         enums.UserPermissionNames.T_A_MY_TIME_PUNCH_RECORDS
    //       )
    //         ? true
    //         : false,

    //     },

    //     {
    //       title: "Plant Library",
    //       icon: "book-open",

    //       href: routes?.hierarchy2?.match,
    //       display: findCurrectPermission(
    //         enums.UserPermissionNames.T_A_MY_TIME_PUNCH_RECORDS
    //       )
    //         ? true
    //         : false,

    //     },
    //     {
    //       title: "Plant Layout",
    //       icon: "book-open",

    //       href: routes?.planylayout?.match,
    //       display: findCurrectPermission(
    //         enums.UserPermissionNames.T_A_MY_TIME_PUNCH_RECORDS
    //       )
    //         ? true
    //         : false,

    //     },
    //     {
    //       title: "Recording Request",
    //       icon: "camera",

    //       href: routes?.RecordingRequest?.match,
    //       display: findCurrectPermission(
    //         enums.UserPermissionNames.T_A_MY_TIME_PUNCH_RECORDS
    //       )
    //         ? true
    //         : false,

    //     },
    //     {
    //       title: "Recording List",
    //       icon: "camera",

    //       href: routes?.Recordinglist?.match,
    //       display: findCurrectPermission(
    //         enums.UserPermissionNames.T_A_MY_TIME_PUNCH_RECORDS
    //       )
    //         ? true
    //         : false,

    //     },
    //     {
    //       title: "Monthly Schedule",
    //       icon: "calendar",
    //       href: routes?.monthlySchedule?.match,
    //       display: true,
    //     },
    //     {
    //       title: "Holiday Schedule",
    //       icon: "calendar",
    //       href: routes?.Holiday?.match,
    //       display: true,
    //     },
    //     {
    //       title: "Phonebook",
    //       icon: "phone",
    //       href: routes?.phonebook?.match,
    //       display: true,
    //     },
    //   ],
    // },

    {
      navlabel: true,
      subheader: "APPS",
      icon: "mdi mdi-dots-horizontal",
      href: "Apps",
      display: false,
    },
    {
      title: "Chat",
      icon: "message-square",
      href: "/chats",
      display: false,
    },
    {
      title: "Notes",
      icon: "clipboard",
      href: "/notes",
      display: false,
    },
    {
      title: "Mail",
      icon: "inbox",
      href: "/email",
      display: false,
    },

    {
      title: "Calendar",
      icon: "calendar",
      href: "/calendar",
      display: false,
    },

    {
      title: "Customers",
      icon: "users",
      href: "/customers",
      collapse: true,
      display: false,
      children: [
        {
          title: "Lists",
          icon: "list",
          href: "/customers/lists",
        },
        {
          title: "Edit",
          icon: "edit",
          href: "/customers/edit",
        },
      ],
    },
    {
      navlabel: true,
      subheader: "PAGES",
      icon: "mdi mdi-dots-horizontal",
      href: "Pages",
      display: false,
    },
    {
      title: "Shop",
      icon: "shopping-cart",
      href: "/shop",
      collapse: true,
      display: false,
      children: [
        {
          title: "Listing",
          icon: "list",
          href: "/shop/lists",
        },
        {
          title: "Detail",
          icon: "file-text",
          href: "/shop/shop-detail",
        },
      ],
    },
    {
      title: "Alert",
      icon: "alert-circle",
      href: "/alert",
      display: false,
    },
    {
      title: "User Profile",
      icon: "user",
      href: "/user-profile",
      display: false,
    },
    {
      title: "Quill Editor",
      icon: "edit",
      href: "/quill-editor",
      display: false,
    },
    {
      title: "Treeview",
      icon: "git-pull-request",
      href: "/treeview",
      display: false,
    },
    {
      title: "Pricing",
      icon: "dollar-sign",
      href: "/pricing",
      display: false,
    },
    {
      title: "Typography",
      icon: "type",
      href: "/typography",
      display: false,
    },
    {
      title: "Feather Icons",
      icon: "feather",
      href: "/react-icons",
      display: false,
    },
    {
      title: "Timeline",
      icon: "clock",
      href: "/timeline",
      display: false,
    },
    {
      navlabel: true,
      subheader: "FORMS",
      icon: "mdi mdi-dots-horizontal",
      href: "Form",
      display: false,
    },
    {
      title: "Form Elements",
      icon: "box",
      href: "/form-elements",
      collapse: true,
      display: false,
      children: [
        {
          title: "Autocomplete",
          icon: "compass",
          href: "/form-elements/autocomplete",
        },
        {
          title: "Buttons",
          icon: "codepen",
          href: "/form-elements/button",
        },
        {
          title: "Checkbox",
          icon: "check-square",
          href: "/form-elements/checkbox",
        },
        {
          title: "Radio",
          icon: "check-circle",
          href: "/form-elements/radio",
        },
        {
          title: "Date Time",
          icon: "calendar",
          href: "/form-elements/date-time",
        },
        {
          title: "Slider",
          icon: "git-commit",
          href: "/form-elements/slider",
        },
        {
          title: "Switch",
          icon: "toggle-left",
          href: "/form-elements/switch",
        },
      ],
    },
    {
      title: "Form Layout",
      icon: "file-text",
      href: "/form-layouts/form-layouts",
      display: false,
    },
    {
      title: "Form Custom",
      icon: "file-plus",
      href: "/form-layouts/form-custom",
      display: false,
    },
    {
      title: "Form Wizard",
      icon: "codepen",
      href: "/form-layouts/form-wizard",
      display: false,
    },
    {
      navlabel: true,
      subheader: "TABLES",
      icon: "mdi mdi-dots-horizontal",
      href: "Table",
      display: false,
    },
    {
      title: "Tables",
      icon: "layout",
      href: "/tables",
      collapse: true,
      display: false,
      children: [
        {
          title: "Basic Table",
          icon: "disc",
          href: "/tables/basic-table",
        },
        {
          title: "Pagination Table",
          icon: "disc",
          href: "/tables/pagination-table",
        },
        {
          title: "Enhanced Table",
          icon: "disc",
          href: "/tables/enhanced-table",
        },
        {
          title: "Collapsible Table",
          icon: "disc",
          href: "/tables/collapsible-table",
        },
        {
          title: "Fixed Header Table",
          icon: "disc",
          href: "/tables/fixed-header-table",
        },
      ],
    },
    {
      navlabel: true,
      subheader: "WIDGETS",
      icon: "mdi mdi-dots-horizontal",
      href: "Widgets",
      display: false,
    },
    {
      title: "Widget Feed",
      icon: "archive",
      href: "/widgets/widget-feed",
      display: false,
    },

    {
      title: "Widget Apps",
      icon: "grid",
      href: "/widgets/widget-apps",
      display: false,
    },
    {
      navlabel: true,
      subheader: "CHARTS",
      icon: "mdi mdi-dots-horizontal",
      href: "Chart",
      display: false,
    },
    {
      title: "Line Chart",
      icon: "activity",
      href: "/charts/line-chart",
      display: false,
    },
    {
      title: "Gredient Chart",
      icon: "bar-chart",
      href: "/charts/gredient-chart",
      display: false,
    },
    {
      title: "Doughnut & Pie",
      icon: "bar-chart-2",
      href: "/charts/doughnut-pie-chart",
      display: false,
    },
    {
      title: "Area Chart",
      icon: "aperture",
      href: "/charts/area-chart",
      display: false,
    },
    {
      title: "Column Chart",
      icon: "circle",
      href: "/charts/column-chart",
      display: false,
    },
    {
      title: "Candlestick Chart",
      icon: "loader",
      href: "/charts/candlestick-chart",
      display: false,
    },
    {
      title: "Radialbar & Radar",
      icon: "octagon",
      href: "/charts/radialbar-chart",
      display: false,
    },
    {
      navlabel: true,
      subheader: "AUTHENTICATION",
      icon: "mdi mdi-dots-horizontal",
      href: "Authentication",
      display: false,
    },
    {
      title: "Log in",
      icon: "log-in",
      href: routes?.login?.match,
      display: false,
    },
    {
      title: "Register",
      icon: "user-plus",
      href: routes?.register?.match,
      display: false,
    },
    {
      title: "Reset Password",
      icon: "refresh-ccw",
      href: routes?.resetPassword?.match,
      display: false,
    },
    {
      title: "Error",
      icon: "alert-triangle",
      href: routes?.error?.match,
      display: false,
    },
    {
      navlabel: true,
      subheader: "IT Panel",
      icon: "mdi mdi-dots-horizontal",
      href: "Dashboard",
      display:
        findCurrectPermission(enums.UserPermissionNames.IT_Panel_MasterSheet) ||
        findCurrectPermission(
          enums.UserPermissionNames.IT_Panel_SkillEnhancement,
        ) ||
        findCurrectPermission(
          enums.UserPermissionNames.IT_Panel_StandardStructure,
        ) ||
        findCurrectPermission(
          enums.UserPermissionNames.IT_Panel_AzureServers,
        ) ||
        findCurrectPermission(enums.UserPermissionNames.IT_Panel_UpcommingPlan)
          ? true
          : false,
    },
    {
      title: "IT",
      icon: "monitor",
      href: "/it",
      collapse: true,
      display:
        findCurrectPermission(enums.UserPermissionNames.IT_Panel_MasterSheet) ||
        findCurrectPermission(
          enums.UserPermissionNames.IT_Panel_SkillEnhancement,
        ) ||
        findCurrectPermission(
          enums.UserPermissionNames.IT_Panel_StandardStructure,
        ) ||
        findCurrectPermission(
          enums.UserPermissionNames.IT_Panel_AzureServers,
        ) ||
        findCurrectPermission(enums.UserPermissionNames.IT_Panel_UpcommingPlan)
          ? true
          : false,
      children: [
        {
          title: "Master Sheet",
          icon: "database",
          collapse: true,
          display:
            findCurrectPermission(
              enums.UserPermissionNames.IT_Panel_MasterSheet_Overview,
            ) ||
            findCurrectPermission(
              enums.UserPermissionNames.IT_Panel_MasterSheet_RunningProject,
            ) ||
            findCurrectPermission(
              enums.UserPermissionNames.IT_Panel_MasterSheet_OngoingTasks,
            ) ||
            findCurrectPermission(
              enums.UserPermissionNames.IT_Panel_MasterSheet_PeriodicActionItem,
            ) ||
            findCurrectPermission(
              enums.UserPermissionNames
                .IT_Panel_MasterSheet_ContinuousImprovementProject,
            ) ||
            findCurrectPermission(
              enums.UserPermissionNames.IT_Panel_MasterSheet_KPIs,
            ) ||
            findCurrectPermission(
              enums.UserPermissionNames
                .IT_Panel_MasterSheet_ResponsibilityMatrix,
            ) ||
            findCurrectPermission(
              enums.UserPermissionNames
                .IT_Panel_MasterSheet_WorkloadDistributor,
            ) ||
            findCurrectPermission(
              enums.UserPermissionNames.IT_Panel_MasterSheet_DepartmentReports,
            ) ||
            findCurrectPermission(
              enums.UserPermissionNames.IT_Panel_MasterSheet_DepartmentTraining,
            )
              ? true
              : false,
          children: [
            {
              title: "Overview",
              icon: "server",
              href: routes?.itDashboard?.match,
              display: findCurrectPermission(
                enums.UserPermissionNames.IT_Panel_MasterSheet_Overview,
              )
                ? true
                : false,
            },
            {
              title: "Running Project",
              icon: "star",
              href: routes?.itNews?.match,
              display: findCurrectPermission(
                enums.UserPermissionNames.IT_Panel_MasterSheet_RunningProject,
              )
                ? true
                : false,
            },
            {
              title: "Ongoing Tasks",
              icon: "activity",
              href: routes?.itOngoingTasks?.match,
              display: findCurrectPermission(
                enums.UserPermissionNames.IT_Panel_MasterSheet_OngoingTasks,
              )
                ? true
                : false,
            },
            {
              title: "Periodic Action Item",
              icon: "refresh-cw",
              href: routes?.itPeriodicActionItem?.match,
              display: findCurrectPermission(
                enums.UserPermissionNames
                  .IT_Panel_MasterSheet_PeriodicActionItem,
              )
                ? true
                : false,
            },
            {
              title: "Continuous Improvement Project",
              icon: "trending-up",
              href: routes?.itContinuousImprovement?.match,
              display: findCurrectPermission(
                enums.UserPermissionNames
                  .IT_Panel_MasterSheet_ContinuousImprovementProject,
              )
                ? true
                : false,
            },
            {
              title: "KPIs",
              icon: "target",
              href: routes?.itKPIs?.match,
              display: findCurrectPermission(
                enums.UserPermissionNames.IT_Panel_MasterSheet_KPIs,
              )
                ? true
                : false,
            },
            {
              title: "Responsibility Matrix",
              icon: "users",
              href: routes?.itResponsibilityMatrix?.match,
              display: findCurrectPermission(
                enums.UserPermissionNames
                  .IT_Panel_MasterSheet_ResponsibilityMatrix,
              )
                ? true
                : false,
            },
            {
              title: "Workload Distributor",
              icon: "pie-chart",
              href: routes?.itWorkloadDistributor?.match,
              display: findCurrectPermission(
                enums.UserPermissionNames
                  .IT_Panel_MasterSheet_WorkloadDistributor,
              )
                ? true
                : false,
            },
            {
              title: "Department Reports",
              icon: "file-text",
              href: routes?.itDepartmentReports?.match,
              display: findCurrectPermission(
                enums.UserPermissionNames
                  .IT_Panel_MasterSheet_DepartmentReports,
              )
                ? true
                : false,
            },
            {
              title: "Department Training",
              icon: "book-open",
              href: routes?.itDepartmentTraining?.match,
              display: findCurrectPermission(
                enums.UserPermissionNames
                  .IT_Panel_MasterSheet_DepartmentTraining,
              )
                ? true
                : false,
            },
          ],
        },
        {
          title: "Standard Structure",
          icon: "folder",
          collapse: true,
          display:
            findCurrectPermission(
              enums.UserPermissionNames.IT_Panel_StandardStructure_DBLibrary,
            ) ||
            findCurrectPermission(
              enums.UserPermissionNames
                .IT_Panel_StandardStructure_ScheduledTasks,
            ) ||
            findCurrectPermission(
              enums.UserPermissionNames.IT_Panel_StandardStructure_CStructure,
            ) ||
            findCurrectPermission(
              enums.UserPermissionNames.IT_Panel_StandardStructure_MVCStructure,
            ) ||
            findCurrectPermission(
              enums.UserPermissionNames
                .IT_Panel_StandardStructure_ReactJSAndDotNetStructure,
            )
              ? true
              : false,
          children: [
            {
              title: "Databse Library",
              icon: "cpu",
              href: routes?.itDatabaseUsage?.match,
              display: findCurrectPermission(
                enums.UserPermissionNames.IT_Panel_StandardStructure_DBLibrary,
              )
                ? true
                : false,
            },
            {
              title: "Scheduled Tasks",
              icon: "clock",
              href: routes?.itSchedulerDataTransfer?.match,
              display: findCurrectPermission(
                enums.UserPermissionNames
                  .IT_Panel_StandardStructure_ScheduledTasks,
              )
                ? true
                : false,
            },
            {
              title: "C# Structure",
              icon: "code",
              href: routes?.itCSharpStructure?.match,
              display: findCurrectPermission(
                enums.UserPermissionNames.IT_Panel_StandardStructure_CStructure,
              )
                ? true
                : false,
            },
            {
              title: "MVC Structure",
              icon: "layout",
              href: routes?.itMVCStructure?.match,
              display: findCurrectPermission(
                enums.UserPermissionNames
                  .IT_Panel_StandardStructure_MVCStructure,
              )
                ? true
                : false,
            },
            {
              title: "React JS & .Net Core structure",
              icon: "layers",
              href: routes?.itReactDotNetStructure?.match,
              display: findCurrectPermission(
                enums.UserPermissionNames
                  .IT_Panel_StandardStructure_ReactJSAndDotNetStructure,
              )
                ? true
                : false,
            },
          ],
        },
        {
          title: "Skill Enhancement",
          icon: "award",
          collapse: true,
          display:
            findCurrectPermission(
              enums.UserPermissionNames.IT_Panel_SkillEnhancement_TechNews,
            ) ||
            findCurrectPermission(
              enums.UserPermissionNames.IT_Panel_SkillEnhancement_GitTraining,
            ) ||
            findCurrectPermission(
              enums.UserPermissionNames.IT_Panel_SkillEnhancement_FEBasics,
            ) ||
            findCurrectPermission(
              enums.UserPermissionNames.IT_Panel_SkillEnhancement_ReactJS,
            ) ||
            findCurrectPermission(
              enums.UserPermissionNames
                .IT_Panel_SkillEnhancement_CCPPDotNewCore,
            ) ||
            findCurrectPermission(
              enums.UserPermissionNames.IT_Panel_SkillEnhancement_MVCDotNetCore,
            )
              ? true
              : false,
          children: [
            {
              title: "Tech News & Updates",
              icon: "radio",
              href: routes?.itOnboardingTechNews?.match,
              display: findCurrectPermission(
                enums.UserPermissionNames.IT_Panel_SkillEnhancement_TechNews,
              )
                ? true
                : false,
            },
            {
              title: "Git Training",
              icon: "git-merge",
              href: routes?.itOnboardingGit?.match,
              display: findCurrectPermission(
                enums.UserPermissionNames.IT_Panel_SkillEnhancement_GitTraining,
              )
                ? true
                : false,
            },
            {
              title: "Frontend Basics",
              icon: "layout",
              href: routes?.itOnboardingFrontend?.match,
              display: findCurrectPermission(
                enums.UserPermissionNames.IT_Panel_SkillEnhancement_FEBasics,
              )
                ? true
                : false,
            },
            {
              title: "React JS",
              icon: "monitor",
              href: routes?.itOnboardingReact?.match,
              display: findCurrectPermission(
                enums.UserPermissionNames.IT_Panel_SkillEnhancement_ReactJS,
              )
                ? true
                : false,
            },
            {
              title: "C, C++, C#",
              icon: "code",
              href: routes?.itOnboardingLanguages?.match,
              display: findCurrectPermission(
                enums.UserPermissionNames
                  .IT_Panel_SkillEnhancement_CCPPDotNewCore,
              )
                ? true
                : false,
            },
            {
              title: "MVC & .NET Core",
              icon: "server",
              href: routes?.itOnboardingDotNet?.match,
              display: findCurrectPermission(
                enums.UserPermissionNames
                  .IT_Panel_SkillEnhancement_MVCDotNetCore,
              )
                ? true
                : false,
            },
          ],
        },
        {
          title: "Azure Servers",
          icon: "cloud",
          href: routes?.itAzureServers?.match,
          display: findCurrectPermission(
            enums.UserPermissionNames.IT_Panel_AzureServers,
          )
            ? true
            : false,
        },
        {
          title: "Upcomming Plan",
          icon: "clipboard",
          href: routes?.itManagerialPlan?.match,
          display: findCurrectPermission(
            enums.UserPermissionNames.IT_Panel_UpcommingPlan,
          )
            ? true
            : false,
        },
      ],
    },
    {
      navlabel: true,
      subheader: "Admin Panel",
      icon: "mdi mdi-dots-horizontal",
      href: "Website",
      display:
        findCurrectPermission(enums.UserPermissionNames.ADMIN_ADD_EMPLOYEE) ||
        findCurrectPermission(enums.UserPermissionNames.ADMIN_EMPLOYEE_LIMIT) ||
        findCurrectPermission(
          enums.UserPermissionNames.ADMIN_APPROVAL_DOCUMENT_PERSON,
        ) ||
        findCurrectPermission(enums.UserPermissionNames.ROLES_PERMISSIONS)
          ? true
          : false,
    },
    {
      title: "Admin",
      icon: "users",
      href: "/admin",
      collapse: true,
      display:
        findCurrectPermission(enums.UserPermissionNames.ADMIN_ADD_EMPLOYEE) ||
        findCurrectPermission(enums.UserPermissionNames.ADMIN_EMPLOYEE_LIMIT) ||
        findCurrectPermission(
          enums.UserPermissionNames.ADMIN_APPROVAL_DOCUMENT_PERSON,
        ) ||
        findCurrectPermission(enums.UserPermissionNames.ROLES_PERMISSIONS)
          ? true
          : false,
      children: [
        {
          title: "Add Employee",
          icon: "list",
          href: routes?.addemployee?.match,
          display: true,
        },
        // {
        //   title: "Employees",
        //   icon: "list",
        //   href: routes?.limitEmployee.match,
        //   subChild: {
        //     href: [
        //       routes?.editEmployee?.matchSidebar,
        //       routes?.employeeView?.matchSidebar,
        //     ],
        //   },
        //   display: findCurrectPermission(
        //     enums.UserPermissionNames.ADMIN_EMPLOYEE_LIMIT
        //   )
        //     ? true
        //     : false,
        // },
        {
          title: "Approval Document Person",
          icon: "list",
          href: routes?.approvalDocument.match,
          display: findCurrectPermission(
            enums.UserPermissionNames.ADMIN_APPROVAL_DOCUMENT_PERSON,
          )
            ? true
            : false,
        },
        {
          title: "Role Rights",
          icon: "list",
          href: routes?.roleRights.match,
          display: findCurrectPermission(
            enums.UserPermissionNames.ROLES_PERMISSIONS,
          )
            ? true
            : false,
        },
        {
          title: "Master Details",
          icon: "list",
          href: routes?.masterDetails.match,
          display: findCurrectPermission(
            enums.UserPermissionNames.Admin_MasterDetails,
          )
            ? true
            : false,
        },
        {
          title: "Application Master",
          icon: "list",
          href: routes?.applicationMaster?.match,
          display: findCurrectPermission(
            enums.UserPermissionNames.Admin_ApplicationMaster,
          )
            ? true
            : false,
        },
        {
          title: "Master Database",
          icon: "database",
          href: routes?.masterDatabase?.match,
          display: findCurrectPermission(
            enums.UserPermissionNames.Admin_MasterDatabase,
          )
            ? true
            : false,
        },
        {
          title: "Request Type Master",
          icon: "list",
          href: routes?.requestTypeMaster?.match,
          display: findCurrectPermission(
            enums.UserPermissionNames.Admin_RequestTypeMaster,
          )
            ? true
            : false,
        },
        {
          title: "Dashboard's Modules Management",
          icon: "list",
          href: routes?.dashboardModulesManagement?.match,
          display: findCurrectPermission(
            enums.UserPermissionNames.Admin_DashboardModuleManagement,
          )
            ? true
            : false,
        },
        {
          title: "EPO Workflow Master",
          icon: "git-branch",
          href: routes?.epoMaster?.match,
          // display: true,
          display: findCurrectPermission(
            enums.UserPermissionNames.Admin_EpoWorkflowMaster,
          )
            ? true
            : false,
        },
        {
          title: "Vendor List",
          icon: "list",
          href: routes?.vendorList?.match,
          display: true,
        },
      ],
    },
    // {
    //   navlabel: true,
    //   subheader: "ASAI Panel",
    //   icon: "mdi mdi-dots-horizontal",
    //   href: "Website",
    //   display: true,
    // },
    // {
    //   title: "ASAI Admin",
    //   icon: "users",
    //   href: "/asaiadmin",
    //   collapse: true,
    //   display: true,
    //   children: [
    //     {
    //       title: "Master",
    //       icon: "database",
    //       href: "/asaiadmin",
    //       collapse: true,
    //       display: true,
    //       subChild: {
    //         href: [
    //           routes?.machineMaster.match,
    //           routes?.leaveMaster.match,
    //           routes?.addLeaveSheet.match,
    //           routes?.shiftMaster.match,
    //           routes?.leaveBalanceMaster.match,
    //           routes?.shiftRuleConfiguration.match,
    //           routes?.organizationMaster.match,
    //         ],
    //       },
    //       children: [
    //         {
    //           title: "Machine Master",
    //           icon: "list",
    //           href: routes?.machineMaster.match,
    //           display: true,
    //         },
    //         {
    //           title: "Leave Master",
    //           icon: "list",
    //           href: routes?.leaveMaster.match,
    //           display: true,
    //         },
    //         {
    //           title: "Leave Sheet",
    //           icon: "list",
    //           href: routes?.allLeaveSheet.match,
    //           display: true,
    //         },
    //         {
    //           title: "Shift Master",
    //           icon: "list",
    //           href: routes?.shiftMaster.match,
    //           display: true,
    //         },
    //         {
    //           title: "Leave Balance Master",
    //           icon: "list",
    //           href: routes?.leaveBalanceMaster.match,
    //           display: true,
    //         },
    //         {
    //           title: "Shift Rule Configuration",
    //           icon: "list",
    //           href: routes?.shiftRuleConfiguration.match,
    //           display: true,
    //         },
    //         {
    //           title: "Organization Master",
    //           icon: "list",
    //           href: routes?.organizationMaster.match,
    //           display: true,
    //         },
    //       ],
    //     },
    //   ],
    // },

    // {
    //   navlabel: true,
    //   subheader: "GENRIC INFORMATION",
    //   icon: "mdi mdi-dots-horizontal",
    //   href: "Website",
    //   display:
    //     findCurrectPermission(enums.UserPermissionNames.T_A_MY_TIME_PUNCH_RECORDS)

    //       ? true
    //       : false,
    // },
    // {
    //   title: "Hierarchy chart",
    //   icon: "pie-chart",

    //   href: routes?.hierarchy?.match,
    //   display: findCurrectPermission(
    //     enums.UserPermissionNames.T_A_MY_TIME_PUNCH_RECORDS
    //   )
    //     ? true
    //     : false,

    // },

    // {
    //   title: "Plant Library",
    //   icon: "book-open",

    //   href: routes?.hierarchy2?.match,
    //   display: findCurrectPermission(
    //     enums.UserPermissionNames.T_A_MY_TIME_PUNCH_RECORDS
    //   )
    //     ? true
    //     : false,

    // },
    // {
    //   title: "Plant Layout",
    //   icon: "book-open",

    //   href: routes?.planylayout?.match,
    //   display: findCurrectPermission(
    //     enums.UserPermissionNames.T_A_MY_TIME_PUNCH_RECORDS
    //   )
    //     ? true
    //     : false,

    // },

    // {
    //   title: "Monthly Schedule",
    //   icon: "calendar",
    //   href: routes?.monthlySchedule?.match,
    //   display: true,
    // },
    // {
    //   title: "Holiday Schedule",
    //   icon: "calendar",
    //   href: routes?.Holiday?.match,
    //   display: true,
    // },
    // {
    //   title: "Phonebook",
    //   icon: "phone",
    //   href: routes?.phonebook?.match,
    //   display: true,
    // },
    {
      navlabel: true,
      subheader: "Departmental Applications",
      icon: "mdi mdi-dots-horizontal",
      href: "Departmental Applications",
      display: showDepartmentalApplications,
      // findCurrectPermission(enums.UserPermissionNames.ADMIN_ADD_EMPLOYEE) ||
      // findCurrectPermission(enums.UserPermissionNames.ADMIN_EMPLOYEE_LIMIT) ||
      // findCurrectPermission(
      //   enums.UserPermissionNames.ADMIN_APPROVAL_DOCUMENT_PERSON
      // )|| findCurrectPermission(
      //       enums.UserPermissionNames.T_A_MY_TIME_PUNCH_RECORDS        ) ||
      // findCurrectPermission(enums.UserPermissionNames.ROLES_PERMISSIONS)
      //   ? true
      //   : false,
    },
    // {
    //   title: "META",
    //   icon: "list",
    //   href: `http://localhost:3000/login?username=${UserName?.name}`,
    //   display: findCurrectPermission(
    //     enums.UserPermissionNames.FTO_SUBMIT_NEW_REQUEST
    //   )
    //     ? true
    //     : false,

    // },
    // {
    //   title: "Conference Booking",
    //   icon: "users",
    //   href: `https://conferencebooking.sswhite.co/`,
    //   display: findCurrectPermission(
    //     enums.UserPermissionNames.FTO_SUBMIT_NEW_REQUEST
    //   )
    //     ? true
    //     : false,

    // },
    //    {
    //   title: "Gatepass",
    //   icon: "list",
    //   href: `http://localhost:3000/login?username=${UserName?.name}`,
    //   display: findCurrectPermission(
    //         enums.UserPermissionNames.T_A_MY_TIME_PUNCH_RECORDS
    //       )
    //         ? true
    //         : false,

    // },
    // {
    //   title: "Gate Pass",
    //   icon: "list",
    //   href: `https://gatepass.sswhite.co?userloginID=${localStorage.getItem("encryptedUserId")}`,
    //   display: findCurrectPermission(
    //     enums.UserPermissionNames.FTO_SUBMIT_NEW_REQUEST
    //   )
    //     ? true
    //     : false,
    // },
    {
      title: "Gate Pass",
      icon: "list",
      href: `https://gatepassnew.sswhite.co/login?username=${UserName?.name}`,
      display: showDepartmentalApplications,
    },
    {
      title: "TPM - Total Procure Master",
      icon: "list",
      href: `https://tpm.sswhite.co/login?username=${encodeURIComponent(
        UserName?.name,
      )}&password=${btoa(UserName?.password)}`,
      display: showDepartmentalApplications,
    },
    {
      title: "EDIOT",
      icon: "list",
      href: `https://ediot.sswhite.co/login?username=${UserName?.name}`,
      display: showDepartmentalApplications,
    },
    {
      title: "META",
      icon: "list",
      href: `https://metanew.sswhite.co/login?username=${UserName?.name}`,
      display: showDepartmentalApplications,
    },

    {
      title: "Conference Booking",
      icon: "users",
      href: `https://conferencebooking.sswhite.co/`,
      display: showDepartmentalApplications,
    },
    {
      title: "E-Library",
      icon: "book-open",
      href: `https://library.sswhite.co/homenew.aspx?username=${encodeURIComponent(
        UserName?.name,
      )}`,
      display: showDepartmentalApplications,
    },
    // {
    //   navlabel: true,
    //   subheader: "Security Screen",
    //   icon: "mdi mdi-dots-horizontal",
    //   href: "Security Screen",
    //   display: findCurrectPermission(
    //     enums.UserPermissionNames.SECURITY_SCREEN
    //   )
    //     ? true
    //     : false,
    // },
    // {
    //   title: "Visitor Pass Display",
    //   icon: "list",
    //   href: routes?.VisitorDisplay.match,
    //   display: findCurrectPermission(
    //     enums.UserPermissionNames.SECURITY_SCREEN
    //   )
    //     ? true
    //     : false,
    // },
    // {
    //   title: "Material Pass Display",
    //   icon: "list",
    //   href: routes?.MaterialPassDisplay.match,
    //   display: findCurrectPermission(
    //     enums.UserPermissionNames.SECURITY_SCREEN
    //   )
    //     ? true
    //     : false,
    // },

    // {
    //   title: "Add Employee",
    //   icon: "list",
    //   href: routes?.addEmployee?.match,
    //   display: findCurrectPermission(
    //     enums.UserPermissionNames.ADMIN_ADD_EMPLOYEE
    //   )
    //     ? true
    //     : false,
    // },
  ];
};

export default Menuitems;
